import { Button } from "@mui/material"
import { useNavigate } from "react-router-dom"
import Iconify from "minimals-template/components/Iconify"
import { setReference } from "lib/@hooks/use-reference"

/**
 * Deep-link into a client's Identity Provider settings.
 *
 * The company page (/app/sfg20-admin/clients/:cid) keeps its selected tab in a reference value
 * rather than the URL, so there is no query string to link to. Setting that reference before
 * navigating is what makes this land on the Identity Provider tab instead of Profile — the same
 * key ("companiesTab") and value ("idp") the page and the SSO tab registration already use.
 */
export function ClientIdpLink({ clientId }) {
    const navigate = useNavigate()

    if (!clientId) return null

    return (
        <Button
            size="small"
            onClick={openIdpSettings}
            endIcon={<Iconify icon="mdi:arrow-top-right" />}
            data-cy={`sso-estate-open-idp-${clientId}`}
        >
            Identity Provider
        </Button>
    )

    function openIdpSettings() {
        setReference({ companiesTab: "idp" }, "companiesTab")
        navigate(`/app/sfg20-admin/clients/${clientId}`)
    }
}
